// @flow
import React from 'react';

import Form from 'components/Form';
import { useTranslation } from 'react-i18next'


type Props = {
    data: any,
    onChange: any => any
}

export default ({ data, biblioId, onChange }: Props) => {
    
    const { t } = useTranslation();

   return (
        <React.Fragment>

            <Form
                form={[
                
                    { label: t("archive"), attr: "archive", type: "display", size: { label: 150, field:400 }},
                    { label: t("title"), attr: "titre", type: "display", size: { label: 150, field:400 }},
                    { label: t("timecode"), attr: "timecode", type: "text", size: { label: 150, field:400 }},
                    { label: t("remarques"), attr: "remarques", type: "text", multi:3 ,size: { label: 150, field:400 }},

                ]}
                data={data}
                onChange={onChange}
            />

        </React.Fragment>

    )
}
